import { Utils } from "./Utils";

export function popMessage(message: string, timeout: number = 3): void {
    popup(message, false, timeout);
}

export function popError(message: string, timeout: number = 30): void {
    console.error(message);
    popup(message, true, timeout);
    Utils.logMessage(message);
}

function popup(msg: string, isError: boolean, timeout: number): void {

    if (msg === null || msg === undefined || msg.length < 2) return;

    const form = document.createElement('form');
    form.classList.add('pop');
    form.classList.add(isError ? 'error' : 'message');

    form.innerHTML = `
        <p>${msg}</p>
        <div class="buttons">
            <button>OK</button>
        </div>
    `;

    const btnOk = form.querySelector('button');
    btnOk?.addEventListener('click', (e: Event) => {
        e.preventDefault();
        form.remove();
    });

    document.body.appendChild(form);
    setTimeout(() => { form.remove(); }, timeout * 1000);
}



